/* eslint-disable no-magic-numbers -- surface tokens are named by number */

import styled from 'styled-components';

export const UpgradePageContainer = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 64px;
  max-width: 1280px;
  margin: 0 auto;
`;

export const UpgradePageRoot = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.surface[1]};
  color: ${props => props.theme.text.primary};
`;
